import React from "react";
import styled from "styled-components";
import { Button } from "antd";

const QuickActionLink = ({
  children,
  type = "default",
  size = "large",
  block = false,
  icon,
  onClick,
  ...props
}) => {
  return (
    <StyledQuickActionLink
      type={type}
      size={size}
      block={block}
      icon={icon}
      onClick={onClick}
      className="quick-action-link"
      {...props}
    >
      {children}
    </StyledQuickActionLink>
  );
};

const StyledQuickActionLink = styled(Button)`
  height: 40px !important;
  font-family: var(--font-secondary) !important;
  font-weight: 500 !important;
  font-size: 0.95rem !important;
  border-radius: 8px !important;
  background: white !important;
  border: 1px solid var(--color-border-light) !important;
  color: #000000 !important;
  margin-bottom: 0.75rem !important;

  /* Force text color */
  span,
  .ant-btn-text {
    color: #000000 !important;
  }

  /* Force icon color */
  .anticon {
    color: #000000 !important;
  }

  &:hover {
    background: var(--color-primary-glow) !important;
    border-color: var(--color-primary) !important;
    color: var(--color-primary) !important;
    transform: translateY(-1px) !important;

    span,
    .ant-btn-text {
      color: var(--color-primary) !important;
    }

    .anticon {
      color: var(--color-primary) !important;
    }
  }
`;

export default QuickActionLink;
